export default __webpack_public_path__ + "static/icon-35-5-a2ff9a354c2bea84e0b7e2d654aaaab3.png";